var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"featured"}},[_c('h2',[_vm._v("This Week's Featured Recipe!")]),_c('ul',{staticClass:"cleanList"},_vm._l((_vm.featuredRecipes),function(recipe){return _c('li',{key:recipe.id},[_vm._v(_vm._s(recipe.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }